/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Table_Event_GroupsInputs */

const en_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Event Groups`)
};

const fr_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des groupes d’événements`)
};

const de_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtzahl der Ereignisgruppen`)
};

const it_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppi di eventi totali`)
};

const ru_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего групп событий`)
};

const es_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos totales`)
};

const zh_cn2_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总事件组`)
};

const ja_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループの合計`)
};

const hi_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल इवेंट समूह`)
};

const pt_pt2_automatic_save_table_event_groups = /** @type {(inputs: Automatic_Save_Table_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Total Event Groups" |
*
* @param {Automatic_Save_Table_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_table_event_groups = /** @type {((inputs?: Automatic_Save_Table_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Table_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_table_event_groups(inputs)
	if (locale === "de") return de_automatic_save_table_event_groups(inputs)
	if (locale === "it") return it_automatic_save_table_event_groups(inputs)
	if (locale === "ru") return ru_automatic_save_table_event_groups(inputs)
	if (locale === "es") return es_automatic_save_table_event_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_table_event_groups(inputs)
	if (locale === "ja") return ja_automatic_save_table_event_groups(inputs)
	if (locale === "hi") return hi_automatic_save_table_event_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_table_event_groups(inputs)
	return en_automatic_save_table_event_groups(inputs)
});